
















import Vue, { PropType } from "vue"

import type { ChargingPlanTemplateStep } from "@/datasource/charging"
import EntityTableCard from "@/components/EntityTableCard.vue"
import StringValue from "@/components/StringValue.vue"
import NumberValue from "@/components/NumberValue.vue"

export default Vue.extend({
  components: {
    EntityTableCard,
  },

  props: {
    value: {
      type: Array as PropType<ChargingPlanTemplateStep[]>,
      default: null,
    },

    label: {
      type: String,
      default: null,
    },

    editable: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      readFunction: () => this.value,
      deleteFunction: (entity: ChargingPlanTemplateStep) => {
        this.value.splice(this.value.indexOf(entity), 1)
        this.$emit("input", this.value)
      },
      blankEntity: {
        durationS: 0,
        chargingState: "CHARGING",
        maxChargingPowerPhase1W: 0,
        maxChargingPowerPhase2W: 0,
        maxChargingPowerPhase3W: 0,
      },
      types: {
        durationS: {
          component: NumberValue,
          label: "Duration (s)",
          props: {
            editable: this.editable,
          },
        },
        chargingState: {
          component: StringValue,
          label: "ChargingState",
          props: {
            editable: this.editable,
          },
        },
        maxChargingPowerPhase1W: {
          component: NumberValue,
          label: "Max Charging Power Phase 1 (W)",
          props: {
            editable: this.editable,
          },
        },
        maxChargingPowerPhase2W: {
          component: NumberValue,
          label: "Max Charging Power Phase 2 (W)",
          props: {
            editable: this.editable,
          },
        },
        maxChargingPowerPhase3W: {
          component: NumberValue,
          label: "Max Charging Power Phase 3 (W)",
          props: {
            editable: this.editable,
          },
        },
      },
    }
  },

  methods: {
    async emit() {
      this.$emit("input", this.value)
    },
  },
})
